import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Drawer, Icon, notification, Menu, Dropdown } from "antd";
import axios from "axios";

import DrawerEstudoIranduba from "../Drawers/DrawerEstudoIranduba";
import DrawerEstudoIrandubaAEE from "../Drawers/DrawerEstudoIrandubaAEE";

import DrawerEstudoIrandubaFundamental from "../Drawers/DrawerEstudoIrandubaFundamental";
import DrawerEstudoIrandubaPreEscola from "../Drawers/DrawerEstudoIrandubaPreEscola";

import ModalEstudoCaso from "../Modal/ModalEstudoCaso";
import ModalEstudoCasoPreEscola from "../Modal/ModalEstudoCasoPreEscola";
import ModalEstudoCasoFundamental from "../Modal/ModalEstudoCasoFundamental";

import EstudoIranduba from "../EstabelecimentosEstudo/EstudoIranduba";

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const EstudosIranduba = () => {
    const [estudos, setEstudos] = useState([]);
    const [isTipoInfantil, setIsTipoInfantil] = useState(false);
    const [estudoId, setEstudoId] = useState(null);
    const [drawerVisible, setDrawerVisible] = useState(false);
    const [drawerVisiblePreEscola, setDrawerVisiblePreEscola] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [modalVisiblePreEscola, setModalVisiblePreEscola] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const montarBotaoVoltar = () => {
        if (localStorage.getItem("opcao_voltar") != null) {
            const opcaoInfo = JSON.parse(localStorage.getItem("opcao_voltar"));
            return (
                <>
                    <Link
                        to={opcaoInfo.link_voltar_curso ? opcaoInfo.link_voltar_curso : opcaoInfo.link_voltar}
                        className="botao-secundario botao-secundario-redondo"
                        onClick={() => opcaoInfo.id_curso && localStorage.setItem("codigo_curso", opcaoInfo.id_curso)}
                        style={{ marginRight: 10, display: "flex", justifyContent: "center", alignItems: "center" }}
                    >
                        <Icon type="arrow-left" />
                    </Link>
                </>
            );
        }
    };

    const handleEditarEstudo = id => {
        setDrawerVisible(true);
        setEstudoId(id);
    };

    const handleEditarEstudoPreEscola = id => {
        setDrawerVisiblePreEscola(true);
        setEstudoId(id);
    };

    const handleViewEstudo = id => {
        setModalVisible(true);
        setEstudoId(id);
    };

    const handleViewEstudoPreEscola = id => {
        setModalVisiblePreEscola(true);
        setEstudoId(id);
    };

    const handleCloseDrawer = () => {
        setDrawerVisible(false);
        setEstudoId(null);
    };

    const handleCloseDrawerPreEscola = () => {
        setDrawerVisiblePreEscola(false);
        setEstudoId(null);
    };

    const handleCloseModal = () => {
        setModalVisible(false);
        setEstudoId(null);
    };

    const handleCloseModalPreEscola = () => {
        setModalVisiblePreEscola(false);
        setEstudoId(null);
    };

    const carregarEstudos = () => {
        setIsLoading(true);

        axios({
            method: "get",
            url: "/api/estudo-caso/carregar-plano-estudo-infantil",
            params: {
                disciplinaId: localStorage.getItem("codigo_curso"),
                tipo: "paee"
            }
        })
            .then(response => {
                setEstudos(response.data.planos);
                setIsTipoInfantil(response.data.tipoFormulario);
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response.data || "Ocorreu um erro ao carregar os estudos de caso.");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const atualizarListagem = () => {
        setDrawerVisible(false);
        setEstudoId(null);
        carregarEstudos();
    };

    const handleDelete = () => {
        setModalVisible(false);
        setEstudoId(null);
        carregarEstudos();
    };

    const handleDeletePreEscola = () => {
        setModalVisiblePreEscola(false);
        setEstudoId(null);
        carregarEstudos();
    };

    useEffect(() => {
        carregarEstudos();
    }, []);

    const menuAdicionar = (
        <Menu>
            <Menu.Item onClick={() => setDrawerVisible(true)}>Adicionar Estudo Creche</Menu.Item>
            <Menu.Item onClick={() => setDrawerVisiblePreEscola(true)}>Adicionar Estudo Pré-Escola</Menu.Item>
        </Menu>
    );

    return (
        <>
            <div className="container container-body">
                <div className="turma-visao-geral">
                    <div className="controlos controlos-fundo ">
                        <div className="bloco-esquerda">
                            <span className="titulo-pagina">Estudos de caso</span>
                        </div>
                        <div className="bloco-direita">
                            {isTipoInfantil ? (
                                <>
                                    <Dropdown overlay={menuAdicionar} placement="bottomLeft">
                                        <Link to="#" className="botao-principal botao-principal-redondo" title="Novo atendimento">
                                            +
                                        </Link>
                                    </Dropdown>
                                </>
                            ) : (
                                <>
                                    <Link
                                        to="#"
                                        className="botao-principal botao-principal-redondo"
                                        title="Novo atendimento"
                                        onClick={() => setDrawerVisible(true)}
                                    >
                                        +
                                    </Link>
                                </>
                            )}

                            {montarBotaoVoltar()}
                        </div>
                    </div>
                    <div className="bloco">
                        <div className="bloco-atendimentos">
                            <div className="titulo-bloco-atendimentos">Estudos criados</div>
                            <div className="lista-planos-atendimentos">
                                {estudos.length === 0 &&
                                    'Nenhum estudo criado ainda. Clique no botão " + " para criar seu primeiro estudo.'}
                                {estudos.map(estudo => (
                                    <React.Fragment key={estudo.id}>
                                        <EstudoIranduba
                                            onEdit={handleEditarEstudo}
                                            onEditPreEscola={handleEditarEstudoPreEscola}
                                            onView={handleViewEstudo}
                                            onViewPreEscola={handleViewEstudoPreEscola}
                                            estudo={estudo}
                                        />
                                    </React.Fragment>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {isTipoInfantil ? (
                <>
                    <DrawerEstudoIrandubaAEE
                        id={estudoId}
                        visible={drawerVisible}
                        onClose={handleCloseDrawer}
                        atualizarListagem={atualizarListagem}
                    />
                    <ModalEstudoCaso id={estudoId} visible={modalVisible} onCancel={handleCloseModal} onDelete={handleDelete} />
                    <DrawerEstudoIrandubaPreEscola
                        id={estudoId}
                        visible={drawerVisiblePreEscola}
                        onClose={handleCloseDrawerPreEscola}
                        atualizarListagem={atualizarListagem}
                    />
                    <ModalEstudoCasoPreEscola
                        id={estudoId}
                        visible={modalVisiblePreEscola}
                        onCancel={handleCloseModalPreEscola}
                        onDelete={handleDeletePreEscola}
                    />
                </>
            ) : (
                <>
                    <DrawerEstudoIrandubaFundamental
                        id={estudoId}
                        visible={drawerVisible}
                        onClose={handleCloseDrawer}
                        atualizarListagem={atualizarListagem}
                    />
                    <ModalEstudoCasoFundamental id={estudoId} visible={modalVisible} onCancel={handleCloseModal} onDelete={handleDelete} />
                </>
            )}
        </>
    );
};

export default EstudosIranduba;
